import { Component, OnInit, Input } from '@angular/core';
import { encapsulation } from '../encapsulation';

@Component({
    selector: 'ubx-bootstrap',
    templateUrl: './bootstrap.component.html',
    host: { class: 'ubx-bootstrap flx p:ab cvr:a pe:n' },
    encapsulation
})
export class UBXBootstrapComponent implements OnInit {
    @Input() columns = 12;
    @Input() xGap: string;

    colors: Array<string>;

    ngOnInit() {
        this.setColors(this.columns);
    }

    private setColors(columns: number) {
        const colors: Array<string> = [];
        switch (columns) {
            case 12:
                colors.push('grn', 'grn', 'ylw', 'ylw', 'crm', 'crm', 'org', 'org', 'pur', 'pur', 'blu', 'blu');
                break;
            case 10:
                colors.push('grn', 'grn', 'ylw', 'ylw', 'crm', 'crm', 'org', 'org', 'pur', 'pur');
                break;
            case 9:
                colors.push('grn', 'grn', 'ylw', 'ylw', 'crm', 'org', 'org', 'blu', 'blu');
                break;
            case 8:
                colors.push('grn', 'grn', 'ylw', 'ylw', 'crm', 'crm', 'org', 'org');
                break;
            case 6:
                colors.push('grn', 'ylw', 'crm', 'org', 'pur', 'blu');
                break;
            case 5:
                colors.push('grn', 'ylw', 'crm', 'org', 'pur');
                break;
            case 4:
                colors.push('grn', 'ylw', 'crm', 'org');
                break;
            case 2:
                colors.push('grn', 'crm');
                break;
        }
        this.colors = colors;
    }
}
